export default {
    APP_ENV: "production",
    APP_VERSION: "8cf55dd37fc861a8f54b199e320c2215a138e58e",
    JOBILLA_API_ROOT: "https://api.jobilla.com/",
    JOBILLA_API_V2_URL: "https://api.jobilla.com/api/v2/",
    FORM_REVALIDATE_SECRET: "jobilla-is-best",
    BOT_API: "https://api.jobilla.com/v1/bot/",
    BOT_WEBSOCKET_API: "wss://api.jobilla.com/v1/bot/",
    BOT_EMBED_URL: "https://storage.googleapis.com/jobilla-widgets/jobibot-widget.js",
    ASSETS_URL: "https://images.jobilla.com/",
    IMAGES_URL: "https://storage.googleapis.com/jobillaweb-production-uploads/",
    NOTIFICATIONS_API: "https://api.jobilla.com/notifications/",
    JOBILLA_URL: "https://jobilla.com/",
    LOGIN_URL: "https://auth.app.jobilla.com/login/",
    LEGACY_USER_SPA_URL: "https://api.jobilla.com/account/",
    CALLBACK_URL: "https://auth.jobilla.com/auth/facebook/callback/",
    JOBILLA_COMPANY_ID: 'JobillaCompany',
    JOBILLA_AUTH_TOKEN: 'JobillaOAuthToken',
    JOBILLA_AUTH_REFRESH_TOKEN: 'JobillaOAuthRefreshToken',
    ATTACHMENT_URL: "https://api.jobilla.com/uploads/user/attachment/",
    JOBILLA_BUSINESS_URL: 'https://yrityksille.jobilla.com',
    ROOT_DOMAIN: "jobilla.com",

    FORM_VIEWER_URL: "https://questionnaires.jobilla.com/",
    V3_FORM_VIEWER_URL: "",
    DEFAULT_LANGUAGE: 'en-GB',

    OAUTH_CLIENT_ID: "2",
    OAUTH_CLIENT_SECRET: "HS1WXY8uZg05TOurHv8C0l3UzSX3fckFd0Y1iJBD",

    BUGSNAG_API_KEY: "f38836de369a47daa1fa0eacd8868272",
    DATADOG_TOKEN: "pubb5ae984b2b8aa81a7a1fdb6022b63977",

    MATOMO_HOST: "",
    MATOMO_CDN_URL: "",
    MATOMO_SITE_ID: "",

    POSTHOG_API_KEY: "phc_bQlNfK1S7STlO0bOEM0BQqZjNAB23KagtFiZJXw0Jul",
    POSTHOG_HOST: "",
    VUE_APP_JOBIBOT_LANDING_PAGE_ASSISTANT_URL: "https://aquinas.jobilla.com",

    GAPI_ID: "825611128957-3njf4mu86ufnclpguvb99dr8bbimnd98.apps.googleusercontent.com",
    INTERCOM_API_KEY: "xwbr0bg3",
    USERIQ_SITE_ID: "88127702",

    APPS: {
        EB: {
            URL: "https://api.jobilla.com/company/eb/",
        },
        TARGET: {
            URL: "https://target.jobilla.com/",
        },
        CANDIDATE_POOL: {
            URL: "https://app.jobilla.com/candidates/",
        },
        SETTINGS: {
            URL: "https://app.jobilla.com/settings/",
        },
        DASHBOARD: {
            URL: "https://app.jobilla.com/",
        },
        FORM_VIEWER: {
            URL: "https://questionnaires.jobilla.com/",
        },
        V3_FORM_VIEWER: {
            URL: '',
        },
        PRIVACY: {
            CANDIDATE_URL: (locale, companyId) => 'https://privacy.jobilla.com/{LOCALE}/{COMPANY}/'
                .replace('{LOCALE}', locale)
                .replace('{COMPANY}', companyId),
            CUSTOMER_URL: (locale = 'en-GB') => 'https://www.jobilla.com/{LOCALE}/legal/'.replace('{LOCALE}', locale.substring(0, 2)),
        },
        NOTIFICATIONS: {
            URL: "https://app.jobilla.com/notifications/",
        },
        PRODUCT: {
            URL: "https://app.jobilla.com/",
        },
        PUBLIC: {
            URL: "https://public.jobilla.com/",
        },
        ADMIN: {
            URL: "",
        },
    },

    PAGES: {
        DATA_PROTECTION_POLICY: {
            PATH: 'data-protection-policy',
        },
        PRIVACY_POLICY: {
            PATH: 'privacy-policy',
        },
        TERMS_AND_CONDITIONS: {
            PATH: 'terms-and-conditions',
        },
    },


    CONTACT: {
        address: {
            company: 'Jobilla Oy',
            street: 'Vilhonkatu 4',
            postal_code: '00100',
            city: 'Helsinki',
            country: 'Finland',
        },
        phone: '+358 45 278 4844',
        email: 'cs-finland@jobilla.com',
        vat_number: '2655898-5',
        customer_service_phone: '+358 40 187 5214'
    },

    SETTINGS: {
        TEMPLATES: {
            RECEIVED: 1,
        },
    },

    KNOWLEDGE_BASE: {
        CANDIDATE_ATTRIBUTES: {
            EN: 'http://help.jobilla.com/en/scoring-and-identifying-candidates-with-candidate-attributes',
            FI: 'https://help.jobilla.com/fi/kandidaattien-osaamisen-tunnistaminen-ja-pisteytys-kandidaattien-ominaisuuksien-avulla',
        },
        ARCHIVING_RECRUITMENT: {
            EN: 'https://help.jobilla.com/en/adjusting-recruitment-visibility',
            FI: 'https://help.jobilla.com/fi/s%C3%A4%C3%A4d%C3%A4-rekrytoinnin-n%C3%A4kyvyytt%C3%A4',
        },
    },
};
